import React from 'react';
import { Link } from 'react-router-dom';

export default function Support() {
  return (
    <div>
      <h2 className="page-title">Support</h2>

      <div className="card">
        <h3>Support Center</h3>
        <p>If you need help with the Image Factory or have questions about image building, please reach out to the DevOps Platform team.</p>
      </div>

      <div className="card">
        <h3>Contact</h3>
        <div className="detail-grid">
          <div className="detail-item">
            <label>Email</label>
            <p><a href="mailto:devops-platform@altium.com" className="link">devops-platform@altium.com</a></p>
          </div>
          <div className="detail-item">
            <label>Slack</label>
            <p><a href="https://altium.slack.com/channels/devops-platform" target="_blank" rel="noopener noreferrer" className="link">#devops-platform</a></p>
          </div>
          <div className="detail-item">
            <label>Documentation</label>
            <p><Link to="/usage" className="link">Usage Guide</Link></p>
          </div>
          <div className="detail-item">
            <label>GitHub</label>
            <p><a href="https://github.com/AltiumNexar/image-factory" target="_blank" rel="noopener noreferrer" className="link">AltiumNexar/image-factory</a></p>
          </div>
        </div>
      </div>

      <div className="card">
        <h3>Common Issues</h3>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
          <div>
            <h4>Build Failures</h4>
            <p>Check the <Link to="/history" className="link">build history page</Link> for detailed step logs. Common causes: invalid blueprint, network issues, or insufficient IAM permissions.</p>
          </div>
          <div>
            <h4>Image Not Available</h4>
            <p>Images take 15-45 minutes to build. Check the <Link to="/history" className="link">build history page</Link> for progress. If distribution is enabled, cross-account sharing may take additional time.</p>
          </div>
          <div>
            <h4>CVE Scanning</h4>
            <p>Security scanning runs automatically after each build via AWS Inspector2. Results appear within 15-30 minutes of image creation. View results on the <Link to="/images" className="link">images page</Link>.</p>
          </div>
          <div>
            <h4>Schedule Not Running</h4>
            <p>Verify the schedule is enabled on the <Link to="/schedules" className="link">Schedules page</Link>. Cron expressions use UTC timezone.</p>
          </div>
        </div>
      </div>
    </div>
  );
}
